export default __webpack_public_path__ + "static/media/Manifacturing.b520c84a.svg";